// extracted by mini-css-extract-plugin
export default {"searchBox":"StandingsSearch_searchBox__MNbTV","text":"StandingsSearch_text__4jM37","search":"StandingsSearch_search__+zEJa"};